import React from 'react'

import { useTranslation } from 'react-i18next'

import MustBePremiumDialog from '@components/shared/dialogs/MustBePremiumDialog'
import MustLoginDialog from '@components/shared/dialogs/MustLoginDialog'
import Divider from '@layout/Divider'
import SideNavItem from '@layout/SideNavMenu/SideNavItem'
import ScoreService from '@services/ScoreService'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'
import PageRoutes from '@utils/page-routes'

const MainNav: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()
  const openDialog = useDialogStore((s) => s.openDialog)

  const createNewScore = async (): Promise<void> => {
    if (!session.current_user) {
      openDialog('must_login')
    } else {
      await ScoreService.createNewScore(session)
    }
  }

  return (
    <>
      <Divider />

      {/* Create a new score */}
      {
        <SideNavItem
          label={t('siteSidebar.newScore')}
          iconName="nf-create"
          onClick={createNewScore}
        />
      }

      {/* Home or My Scores */}
      {session.current_user ? (
        <SideNavItem
          href={PageRoutes.homePath()}
          label={t('palette.myScores')}
          iconName="nf-myscores"
          external
        />
      ) : (
        <SideNavItem href="/" label={t('siteSidebar.home')} iconName="nf-home" external />
      )}

      {session.community?.enable_browse_and_search && (
        <>
          {/* Community */}
          {(session.current_user || session.community.allow_anonymous_view) && (
            <SideNavItem
              href={PageRoutes.communityPath()}
              external
              label={t('palette.community')}
              iconName="nf-community-sm"
              iconSize="text-h3"
            />
          )}
          {/* Manage Site */}
          {session.communityGroup &&
            session.current_user &&
            ['admin', 'instructor'].includes(session.community_member?.sso_user_role ?? '') && (
              <SideNavItem
                href={PageRoutes.groupPath(session.communityGroup.id)}
                external
                label={t('palette.manageSite')}
                iconName="nf-manage"
              />
            )}
          {/* Marketplace */}
          {session.community.default_community && (
            <SideNavItem
              href="/music"
              label={t('palette.music')}
              iconSize="text-xl"
              iconName="nf-music-sm"
            />
          )}
        </>
      )}

      {!session.community.default_community &&
        (session.current_user || session.community.allow_anonymous_view) && (
          <SideNavItem
            href="/music"
            label={t('palette.music')}
            iconSize="text-xl"
            iconName="nf-music-sm"
          />
        )}

      <MustLoginDialog title={t('content.newScore')} action={t('action.createAScore')} />
      <MustBePremiumDialog title={t('content.newScore')} action={t('action.addMoreScores')} />
    </>
  )
}

export default MainNav
